exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adder-card,.adder-card .v-input--selection-controls .v-icon,.adder-card .v-input--selection-controls .v-input__control{color:#006aff}.adder-card .v-input--selection-controls.v-input .v-label{color:#000}.adder-card.srp-card .v-input--selection-controls{margin-top:8px}.adder-card.srp-card .card-title .v-input__slot{margin-bottom:0}.adder-card .v-image{border-radius:0}", ""]);

// exports
